import { Contract } from 'ethers';
import getAddress from './getNftBurnAddress';
import abi from '../abis/NftBurnAbi.json';



export default function getNftBurnContract(chainNumber, library, withSigner) {
  const address = getAddress(chainNumber);
  if (!address) return null;
  if (withSigner)
    return new Contract(address, abi, library.getSigner());
  return new Contract(address, abi, library);
}
